import { ArrowUpIcon } from "lucide-react";

import { Card } from "./card";
import { Textarea } from "./textarea";
import { cn } from "../../ui/utils";

type TextViewProps = {
  className?: string;
  isConnected: boolean;
  textInput: string;
  onTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onSend: () => void;
  onEnd: () => void;
  endDisabled?: boolean;
};

const TextConversationView = ({
  className,
  isConnected,
  textInput,
  onTextChange,
  onKeyDown,
  onSend,
  onEnd,
  endDisabled = false,
}: TextViewProps) => {
  return (
    <Card className={cn("border-0 bg-transparent p-0 shadow-none", className)}>
      <div className="flex items-end gap-2">
        <Textarea
          value={textInput}
          onChange={onTextChange}
          onKeyDown={onKeyDown}
          placeholder={isConnected ? "Type your message..." : "Connecting..."}
          disabled={!isConnected}
          className="h-12 min-h-12 resize-none rounded-lg border border-slate-400 bg-white px-4 py-3 shadow-none focus-visible:ring-0 text-sm md:text-base"
        />
        <button
          type="button"
          onClick={onSend}
          disabled={!textInput.trim() || !isConnected}
          className={cn(
            "flex h-11 w-12 items-center justify-center rounded-full bg-primary text-white border-0 p-1 mb-1 cursor-pointer",
            (!textInput.trim() || !isConnected) && "opacity-50",
          )}
          aria-label="Send message"
        >
          <ArrowUpIcon className="h-4 w-4" />
        </button>
      </div>
      <button
        type="button"
        onClick={onEnd}
        disabled={endDisabled}
        className={cn(
          "text-[#71717A] border-0 w-fit mx-auto bg-white underline cursor-pointer text-sm",
          endDisabled && "opacity-50 cursor-not-allowed",
        )}
      >
        End Chat
      </button>
    </Card>
  );
};

export default TextConversationView;
